"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var React = require("react");
var Icon_style_1 = require("./Icon.style");
var list_1 = require("./list");
exports.Icon = function (props) {
    var icon = props.icon, _a = props.size, size = _a === void 0 ? '100%' : _a, style = props.style, _b = props.colorPrimary, colorPrimary = _b === void 0 ? '#0B2641' : _b, _c = props.colorSecondary, colorSecondary = _c === void 0 ? '#25B3EB' : _c, className = props.className;
    return (React.createElement(Icon_style_1.default.Icon, { width: size, height: size, className: className, xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 100 100", style: style },
        React.createElement(list_1.default, { icon: icon, colorPrimary: colorPrimary, colorSecondary: colorSecondary })));
};
exports.default = exports.Icon;
//# sourceMappingURL=Icon.js.map